import React from 'react';
import { useSelector } from 'react-redux';

import {
  userEntitiesSelector,
  loadingSelector,
  isSuperAdminRoleSelector,
  isAdminRoleSelector,
} from '../../ducks/user';
import config from '../../config';

export function adminSuperAdminPrivate(Component) {
  return function WrappedComponent(props) {
    const loading = useSelector(loadingSelector);
    const userData = useSelector(userEntitiesSelector);
    const encodeUri = encodeURIComponent(window.location.href);
    const redirectUrl = `/account/signin?returnurl=${encodeUri}`;

    const isSuperAdmin = useSelector(isSuperAdminRoleSelector);
    const isAdmin = useSelector(isAdminRoleSelector);

    if (loading) return null;
    return (isAdmin || isSuperAdmin) && !config.institution ? (
      <Component {...props} user={userData} />
    ) : (
      location.replace(redirectUrl)
    );
  };
}
